import { AppType } from 'src/app/shared/enums/AppType.enum';
import UserPaymentType from './UserPaymentType.enum';

export class RegisterRequest {
  public recaptchaToken: string = null;
  public appType: AppType = null;

  constructor(
    public firstName: string,
    public lastName: string,
    public userName: string,
    public password: string,
    public phone:string,
    public countryId:number,
    public userPaymentType?: UserPaymentType,
    public isOrganization: boolean = false,
    public emailSessionToken: string = null) {
  }
}
